import { z } from "zod";
import { cosmeticTypeSchema } from "./enum.js";

export const cosmeticSummarySchema = z.object({
	id: z.string(),
	code: z.string(),
	type: cosmeticTypeSchema,
	label_key: z.string(),
	asset_url: z.string().nullable(),
	required_level: z.number().int().nonnegative().nullable(),
	required_badge_id: z.string().nullable(),
	display_order: z.number().int(),
	default_unlocked: z.boolean(),
	unlocked_at: z.number().int().positive().nullable(),
	is_equipped: z.boolean(),
});

export type CosmeticSummary = z.infer<typeof cosmeticSummarySchema>;

export const cosmeticListResponseSchema = z.object({
	user_id: z.string(),
	cosmetics: z.array(cosmeticSummarySchema),
	unlocked_count: z.number().int().nonnegative(),
	total_count: z.number().int().nonnegative(),
});

export type CosmeticListResponse = z.infer<typeof cosmeticListResponseSchema>;

export const unequipCosmeticBodySchema = z.object({
	type: cosmeticTypeSchema,
});

export type UnequipCosmeticBody = z.infer<typeof unequipCosmeticBodySchema>;

export const equipCosmeticResponseSchema = z.object({
	cosmetic_id: z.string(),
	type: cosmeticTypeSchema,
	is_equipped: z.boolean(),
});

export type EquipCosmeticResponse = z.infer<typeof equipCosmeticResponseSchema>;
